import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { useDisclosureContext } from './useDisclosureContext'
import { Color } from '../../constants/color'
import { theme } from '../../constants/theme'

const BodyElement = styled.div<{ floating: boolean; open?: boolean }>(
  (props) => ({
    backgroundColor: props.floating ? undefined : Color.WHITE,
    border: props.floating ? undefined : theme.border.style.thin,
    borderBottomLeftRadius: theme.border.radius.normal,
    borderBottomRightRadius: theme.border.radius.normal,
    borderTop: 'none',
    display: props.open ? 'block' : 'none',
    padding: props.floating ? 0 : 20,
    paddingTop: props.floating ? 8 : undefined,
  }),
)

export type BodyProps = {
  alwaysRender?: boolean
  children?: ReactNode
}

export const Body = ({ alwaysRender, children }: BodyProps) => {
  const { floating, isOpen } = useDisclosureContext()

  return alwaysRender || isOpen ? (
    <BodyElement floating={floating} open={isOpen}>
      {children}
    </BodyElement>
  ) : null
}
